import { render, staticRenderFns } from "./BrandOrVendor.vue?vue&type=template&id=1de21cbd&scoped=true"
import script from "./BrandOrVendor.vue?vue&type=script&lang=js"
export * from "./BrandOrVendor.vue?vue&type=script&lang=js"
import style0 from "./BrandOrVendor.vue?vue&type=style&index=0&id=1de21cbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de21cbd",
  null
  
)

export default component.exports